import zip from 'lodash/zip';

import { connect } from 'react-redux';

import { getSelectedSample } from 'store/scenes/bootstrapCIs/samples/selectors';
import { getPrimaryParameter } from 'store/scenes/bootstrapCIs/primaryParameter/selectors';
import { getSecondaryParameter } from 'store/scenes/bootstrapCIs/secondaryParameter/selectors';

import NumericalComponent from './Component';

const mapStateToProps = state => {
  const primaryParameter = getPrimaryParameter(state);
  const secondaryParameter = getSecondaryParameter(state);

  return ({
    primaryParameterName: primaryParameter.name,
    secondaryParameterName: secondaryParameter.name,

    sampleDots: getSelectedSample(state),

    datasetDots: zip(
      primaryParameter.values,
      secondaryParameter.values
    )
  });
};

export default connect(mapStateToProps)(NumericalComponent);
